// Central API config — all requests go through here
const API_BASE = 'https://api.msdiscoveries.com/api';
const ADMIN_SECRET = process.env.REACT_APP_ADMIN_SECRET || 'msdiscoveries_admin_2025';

// Helper: throws with a useful message on non-OK responses
const safeFetch = (url, opts = {}) =>
  fetch(url, opts).then(r => {
    if (!r.ok) throw new Error(`API error ${r.status}: ${url}`);
    return r.json();
  });

export const api = {
  // ── Public blog ──────────────────────────────
  getBlogPosts: () =>
    safeFetch(`${API_BASE}/blog`),

  getBlogPost: (slug) =>
    safeFetch(`${API_BASE}/blog/${slug}`),

  // ── Admin blog ───────────────────────────────
  adminGetPosts: () =>
    safeFetch(`${API_BASE}/admin/blog`, {
      headers: { 'x-admin-secret': ADMIN_SECRET }
    }),

  adminCreatePost: (post) =>
    safeFetch(`${API_BASE}/admin/blog`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-admin-secret': ADMIN_SECRET },
      body: JSON.stringify(post)
    }),

  adminUpdatePost: (id, post) =>
    safeFetch(`${API_BASE}/admin/blog/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'x-admin-secret': ADMIN_SECRET },
      body: JSON.stringify(post)
    }),

  adminDeletePost: (id) =>
    safeFetch(`${API_BASE}/admin/blog/${id}`, {
      method: 'DELETE',
      headers: { 'x-admin-secret': ADMIN_SECRET }
    }),

  // ── Admin submissions ─────────────────────────
  adminGetSubmissions: () =>
    safeFetch(`${API_BASE}/admin/submissions`, {
      headers: { 'x-admin-secret': ADMIN_SECRET }
    }),

  adminMarkRead: (id) =>
    safeFetch(`${API_BASE}/admin/submissions/${id}/read`, {
      method: 'PUT',
      headers: { 'x-admin-secret': ADMIN_SECRET }
    }),

  adminDeleteSubmission: (id) =>
    safeFetch(`${API_BASE}/admin/submissions/${id}`, {
      method: 'DELETE',
      headers: { 'x-admin-secret': ADMIN_SECRET }
    }),

  // ── Contact ───────────────────────────────────
  submitContact: (data) =>
    safeFetch(`${API_BASE}/contact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }),

  // ── Newsletter ────────────────────────────────
  subscribe: (email) =>
    safeFetch(`${API_BASE}/newsletter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    }),
};